var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceCrazyEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 96,
    viewBox: "0 0 200 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.191 53.3091C84.191 76.4709 65.441 95.2208 42.2793 95.2208C19.1176 95.2208 0 76.4709 0 53.3091C0 30.1474 18.75 11.3975 41.9117 11.3975C65.0734 11.3975 84.191 30.1474 84.191 53.3091Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9706 52.2057C63.9706 57.7204 59.5588 62.1322 54.0441 62.1322C48.5294 62.1322 44.1177 57.7204 44.1177 52.2057C44.1177 46.6911 48.5294 42.2793 54.0441 42.2793C59.5588 42.2793 63.9706 46.6911 63.9706 52.2057Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.177 41.9117C116.177 65.0734 134.927 83.8233 158.088 83.8233C181.25 83.8233 200 65.0734 200 41.9117C200 18.75 181.25 0 158.088 0C134.927 0 116.177 18.75 116.177 41.9117Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.029 40.8083C136.029 46.323 140.441 50.7347 145.956 50.7347C151.47 50.7347 155.882 46.323 155.882 40.8083C155.882 35.2936 151.47 30.8818 145.956 30.8818C140.441 30.8818 136.029 35.2936 136.029 40.8083Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceCrazyEye);
export default __webpack_public_path__ + "static/media/face_crazy_eye.069dd2a3126b2255b31000306d6d5cd7.svg";
export { ForwardRef as ReactComponent };